import { useBrooklynUserJwtContext } from '@yi/core/src/brooklyn-jwt/BrooklynUserJwtProvider';
import { getAccessTier } from '@yi/core/src/user-access';

import { loggers } from '~/src/common/loggers';
import { useCurrentUser } from '~/src/common/user';

const { logChange } = loggers.entitlements;

export const useAccessTier = () => {
  const { currentUser, loading: loadingUser } = useCurrentUser();
  const { parsedJwt, loading: loadingJwt, error: errorJwt } = useBrooklynUserJwtContext();

  const accessTier = getAccessTier({
    currentUser,
    parsedJwt,
    log: msg => logChange('getAccessTier', msg),
  });

  const loading = loadingUser || loadingJwt;
  const tier = loading ? null : accessTier;

  return {
    loading,
    error: errorJwt,
    tier,
    hasMembershipAccess: tier === 'Digital' || tier === 'Premium',
  };
};
